import Vue from 'vue'
import Router from 'vue-router'

import Search from '@/components/Pages/PlayerSearch'

Vue.use(Router)

export default new Router ({
    routes: [
        {path: '/', name: 'PlayerSearch', component: Search},
    ]
})